const AUTH_UNAUTHORIZED_EVENT = "auth:unauthorized";

export type AuthUnauthorizedDetail = {
  reason: "token-expired" | "unauthorized";
  message?: string;
};

export function emitAuthUnauthorized(detail: AuthUnauthorizedDetail) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<AuthUnauthorizedDetail>(AUTH_UNAUTHORIZED_EVENT, { detail })
  );
}

export function onAuthUnauthorized(
  handler: (detail: AuthUnauthorizedDetail) => void
) {
  if (typeof window === "undefined") return () => {};
  const listener: EventListener = (event) => {
    const customEvent = event as CustomEvent<AuthUnauthorizedDetail>;
    handler(
      customEvent.detail ?? {
        reason: "unauthorized",
      }
    );
  };
  window.addEventListener(AUTH_UNAUTHORIZED_EVENT, listener);
  return () => window.removeEventListener(AUTH_UNAUTHORIZED_EVENT, listener);
}
